// @flow
import * as React from 'react'

export type Props = {
  children: React.Node,
  narrow?: boolean,
}

export default class ContentWidthConstraint extends React.Component<Props> {
  render = () => {
    return <div className={this.className}>{this.props.children}</div>
  }

  get className(): string {
    return `ContentWidthConstraint ${this.props.narrow ? 'ContentWidthConstraint--narrow' : ''}`
  }
}
